/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/QueryResultsAPI'
], (_, APIFactory, QueryResultsAPI) => {

	const DATA = 'data';
	class QueryResults {
		constructor(resultTag, warnings) {
			this._oQueryResults = {};
			this._resultTag = resultTag;
			this._warnings = warnings;
		}

		destroy() {
			_.each(this._oQueryResults, results => {
				_.each(results, result => {
					result.destroy && result.destroy();
				});
			});
		}

		getAPI() {
			if (!this.queryResultsAPI) {
				this.queryResultsAPI = APIFactory.createAPI(this, [QueryResultsAPI]);
			}
			return this.queryResultsAPI;
		}

		addResult(queryResult, id = DATA, type = QueryResultsAPI.QUERY_RESULT_TYPE.MAIN) {
			if (!this._oQueryResults[id]) {
				this._oQueryResults[id] = {};
			}
			this._oQueryResults[id][type] = queryResult;
		}

		getResult(id = DATA, type = QueryResultsAPI.QUERY_RESULT_TYPE.MAIN) {
			const result = this._oQueryResults[id] && this._oQueryResults[id][type];
			return result && result.getAPI ? result.getAPI() : result;
		}

		removeResult(id = DATA, type = QueryResultsAPI.QUERY_RESULT_TYPE.MAIN) {
			if(this._oQueryResults[id] && this._oQueryResults[id][type]){
				delete this._oQueryResults[id][type];
			}
		}

		getQueryResultIdList() {
			return this._oQueryResults && Object.keys(this._oQueryResults);
		}

		getCacheValidateTag() {
			return this._resultTag;
		}

		getWarningList() {
			return this._warnings || [];
		}
	}

	return QueryResults;
});